import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export const HeroSection = () => {
  return <section className="w-full bg-gradient-to-br from-blue-50 to-white py-16 md:py-24" data-id="element-146">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-148">
          <div className="w-full lg:w-1/2 space-y-8" data-id="element-149">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight" data-id="element-150">
              Hire top sales talent{' '}
              <span className="text-blue-600" data-id="element-151">faster and smarter</span>
            </h1>
            <p className="text-xl text-gray-600" data-id="element-152">
              ApplicantPass is the only ATS designed specifically for
              high-volume sales recruiting that helps you find, evaluate, and
              hire the best sales professionals with ease.
            </p>
            <div className="space-y-3" data-id="element-153">
              <div className="flex items-center" data-id="element-154">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-155" />
                <span className="text-gray-700" data-id="element-156">
                  Screen 5x more candidates in half the time
                </span>
              </div>
              <div className="flex items-center" data-id="element-157">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-158" />
                <span className="text-gray-700" data-id="element-159">
                  AI-powered sales aptitude assessment
                </span>
              </div>
              <div className="flex items-center" data-id="element-160">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-161" />
                <span className="text-gray-700" data-id="element-162">
                  Reduce time-to-hire by 40%
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-163">
              <a href="#contact" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors text-center" data-id="element-164">
                Request Demo
              </a>
              <a href="#how-it-works" className="px-6 py-3 bg-white text-blue-600 font-medium rounded-md border border-blue-200 hover:border-blue-300 transition-colors text-center" data-id="element-165">
                Learn More
              </a>
            </div>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-166">
            <div className="relative" data-id="element-167">
              <div className="absolute inset-0 bg-blue-200 rounded-lg transform translate-x-3 translate-y-3" data-id="element-168"></div>
              <div className="relative bg-white p-6 rounded-lg shadow-lg" data-id="element-169">
                <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Sales team using ApplicantPass" className="w-full h-auto rounded-md" data-id="element-170" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};